// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {withRouter} from "react-router-dom";
// Components
import {Checkbox, FormControlLabel} from "@material-ui/core";
// Translations
import {withTranslation} from "react-i18next";

class RolesCampaigns extends Component {

    render() {
        const {t, user, updateAction} = this.props;
        const {plan} = this.props.data;
        return (
            plan?.whatsapp_phones?.length > 0 && plan?.platform?.centripush &&
            <div style={{display: "grid"}}>
                <FormControlLabel
                    control={<Checkbox onClick={() => {
                        updateAction("templates");
                    }} checked={user.campaigns.access.templates ?? false}/>}
                    label={t("users.content.campaigns_templates")}
                    labelPlacement="start"
                />
                <FormControlLabel
                    control={<Checkbox onClick={() => {
                        updateAction("groups");
                    }} checked={user.campaigns.access.groups ?? false}/>}
                    label={t("users.content.campaigns_groups")}
                    labelPlacement="start"
                />
                <FormControlLabel
                    control={<Checkbox onClick={() => {
                        updateAction("individual");
                    }} checked={user.campaigns.access.individual ?? false}/>}
                    label={t("users.content.campaigns_individual")}
                    labelPlacement="start"
                />
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        data: state
    };
};

const c = connect(
    mapStateToProps
)(RolesCampaigns);

export default withTranslation("users")(withRouter(c));